var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearAll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46585 8.01308L15.6959 1.78281C16.1014 1.37755 16.1014 0.722316 15.6959 0.317063C15.2907 -0.0881908 14.6354 -0.0881908 14.2302 0.317063L7.99991 6.54733L1.76983 0.317063C1.36438 -0.0881908 0.709336 -0.0881908 0.304082 0.317063C-0.101361 0.722316 -0.101361 1.37755 0.304082 1.78281L6.53417 8.01308L0.304082 14.2434C-0.101361 14.6486 -0.101361 15.3038 0.304082 15.7091C0.506045 15.9113 0.771595 16.0128 1.03696 16.0128C1.30232 16.0128 1.56768 15.9113 1.76983 15.7091L7.99991 9.47883L14.2302 15.7091C14.4323 15.9113 14.6977 16.0128 14.9631 16.0128C15.2284 16.0128 15.4938 15.9113 15.6959 15.7091C16.1014 15.3038 16.1014 14.6486 15.6959 14.2434L9.46585 8.01308Z",
    fill: "#BFBFBF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearAll);
export default __webpack_public_path__ + "static/media/clear_all.9310348e0cbeb191887bdba1659b7666.svg";
export { ForwardRef as ReactComponent };